module.exports = __webpack_public_path__ + "static/media/top_banner_5.f14e23a9.png";